"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["base", "platform", "format", "packageName", "scope", "version"];
/**
 * Npm Size
 *
 * `/bundlephobia/:format/:packageName`
 * npm bundle size:  npm bundle size badge
 *
 * `/bundlephobia/:format/:scope/:packageName`
 * npm bundle size (scoped): npm bundle size (scoped) badge
 *
 * `/bundlephobia/:format/:packageName/:version`
 * npm bundle size (version):  npm bundle size (version) badge
 *
 * `/bundlephobia/:format/:scope/:packageName/:version`
 * npm bundle size (scoped version): npm bundle size (scoped version) badge
 *
 */
var Size = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'npm' : _props$platform,
    _props$format = props.format,
    format = _props$format === void 0 ? 'min' : _props$format,
    packageName = props.packageName,
    scope = props.scope,
    version = props.version,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'npm') return '';
    var baseData = [base, 'bundlephobia'];
    var url = '';
    if (packageName && format) {
      url = [].concat(baseData, [format, packageName]).join('/');
    }
    if (packageName && format && scope) {
      url = [].concat(baseData, [format, scope, packageName]).join('/');
    }
    if (packageName && format && scope && version) {
      url = [].concat(baseData, [format, scope, packageName, version]).join('/');
    }
    if (packageName && format && version) {
      url = [].concat(baseData, [format, packageName, version]).join('/');
    }
    return url;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Size.displayName = 'Size';
var _default = exports["default"] = Size;
module.exports = exports.default;